import Tooltip from "@mui/material/Tooltip";

/**
 * @param {string} txt - The income text to be sliced.
 * @param {number} [max = 50] - The maximum length before truncation
 * @returns The sliced text with (---) appended if truncated
 */

export function TextSlicer({ txt, max = 50 }) {
  return (
    <Tooltip title={txt}>
      {txt ? (txt?.length >= max ? `${txt?.slice(0, max)}...` : txt) : "N/A"}
    </Tooltip>
  );
}
